import { isExpert, isProTeam } from "../../../utils";

export enum ProFormTabs {
    Basics = "Basics",
    IntroVideos = "Intro Videos",
    ContactInfo = "Contact Info",
    Demographics = "Demographics",
    Profession = "Profession",
    ExpertQualification = "Expert Qualification",
    SocialReach = "Social Reach",
    Activity = "Activity",
    CommunityEngagement = "Community Engagement",
    Experties = "Expertise",
    Interests = "Interests",
    KeyPoints = "Key Points",
    Referrals = "Referrals",
    MSA = "MSA"
}
export const getValidProFormTabs = (role: string) => {
    const isProT = isProTeam(role);
    return [
        { label: ProFormTabs.Basics, shouldShow: true },
        { label: ProFormTabs.IntroVideos, shouldShow: true },
        { label: ProFormTabs.ContactInfo, shouldShow: true },
        { label: ProFormTabs.Demographics, shouldShow: true },
        { label: ProFormTabs.Profession, shouldShow: isProT || isExpert(role) },
        { label: ProFormTabs.ExpertQualification, shouldShow: true },
        { label: ProFormTabs.SocialReach, shouldShow: true },
        { label: ProFormTabs.Activity, shouldShow: isProT },
        { label: ProFormTabs.CommunityEngagement, shouldShow: isProT },
        { label: ProFormTabs.Experties, shouldShow: isProT },
        { label: ProFormTabs.Interests, shouldShow: isProT },
        { label: ProFormTabs.KeyPoints, shouldShow: isProT },
        { label: ProFormTabs.Referrals, shouldShow: isProT },
        { label: ProFormTabs.MSA, shouldShow: true }
    ];
};

export interface IProPercentage {
    [key: string]: number;
}

export const defaultTabsPercentage: IProPercentage = {
    [ProFormTabs.Basics]: 0,
    [ProFormTabs.IntroVideos]: 0,
    [ProFormTabs.ContactInfo]: 0,
    [ProFormTabs.Demographics]: 0,
    [ProFormTabs.ExpertQualification]: 0,
    [ProFormTabs.SocialReach]: 0,
    [ProFormTabs.Activity]: 0,
    [ProFormTabs.CommunityEngagement]: 0
};

const getPercentage = (arr: Array<string | number | boolean>): number => {
    const validValues = arr.filter((val) => {
        if (typeof val === "string") return val.trim() !== "";
        if (typeof val === "number") return val > 0;
        if (typeof val === "boolean") return true;
        return !!val;
    });
    return (validValues.length / arr.length) * 100;
};

export const getProfilePercentage = (objArr: any): IProPercentage => {
    const pro = { ...objArr };
    const initialVal = defaultTabsPercentage;
    const basics = [
        pro.emailAddress,
        pro.slug,
        pro.password,
        pro.firstName,
        pro.lastName,
        pro.displayName,
        pro.avatar,
        pro.isProfileCompleted,
        pro.description,
        pro.short_description,
        pro.status,
        pro.notes,
        pro.persona
    ];

    const introVideos = [pro.video1, pro.video2];

    const contactInfo = [
        pro.agencyType,
        pro.agencyName,
        pro.agencyEmail,
        pro.agencyPhoneNumber,
        pro.phoneNumber,
        pro.website,
        pro.address1,
        pro.address2,
        pro.city,
        pro.state,
        pro.zipcode,
        pro["payRateProduction-fullDay"],
        pro["payRateProduction-halfDay"],
        pro["payRate-productTesting"],
        pro["payRateSmp-instagram"],
        pro["payRateSmp-twitter"],
        pro["payRateSmp-tiktok"],
        pro.msaAgreementSigned
    ];

    const demographics = [
        pro.gender,
        pro.pronouns,
        pro.ethnicity,
        pro.isParent,
        pro.dateOfBirth
        // pro.region,
    ];

    const qualification = [
        pro.levelOfEducation,
        pro.fieldOfStudy,
        pro.jobTitle,
        pro.company,
        pro.employmentStatus,
        pro.organizationSeniority,
        pro.professionalStanding,
        pro.monetization,
        pro.recognition,
        pro.pressCoverage,
        pro.openToPromotional,
        pro.audienceReach,
        pro.cameraPresence,
        pro.areasOfExpertise,
        pro.previousContent
    ];

    const socialReach = [
        pro.facebook,
        pro.facebookFollowers,
        pro.twitter,
        pro.twitterFollowers,
        pro.instagram,
        pro.instagramFollowers,
        pro.tiktok,
        pro.tiktokFollowers,
        pro.youtube,
        pro.youtubeSubscribers,
        pro.pinterest,
        pro.pinterestFollowers,
        pro.linkedin
    ];

    const acitivty = [
        pro.productionStatus,
        pro.totalIncome,
        pro.totalProjects,
        pro.reviewsFilmed,
        pro["how-tosFilmed"],
        pro.classesFilmed,
        pro.totalVideosPublished,
        pro.lastProductionDate,
        pro.daysSinceLastProduction,
        pro.totalClients,
        pro.isWebProfileComplete,
        pro.proSpotlight
    ];

    const communityEngagement = [
        pro.communityEngagementScore,
        pro.isEmailSubscriber,
        pro.emailRating,
        pro.emailOpens,
        pro.isInFacebookGroup,
        pro.eventsAttended,
        pro.eventAttendancePercent,
        pro.thirtyDayInquiry,
        pro.sixtyDayInquiry
    ];

    initialVal[ProFormTabs.Basics] = getPercentage(basics);
    initialVal[ProFormTabs.IntroVideos] = getPercentage(introVideos);
    initialVal[ProFormTabs.ContactInfo] = getPercentage(contactInfo);
    initialVal[ProFormTabs.Demographics] = getPercentage(demographics);
    initialVal[ProFormTabs.ExpertQualification] = getPercentage(qualification);
    initialVal[ProFormTabs.SocialReach] = getPercentage(socialReach);
    initialVal[ProFormTabs.Activity] = getPercentage(acitivty);
    initialVal[ProFormTabs.CommunityEngagement] = getPercentage(communityEngagement);

    return initialVal;
};

export const getFullProfilePercentage = (pro: any) => {
    const percentage = getProfilePercentage(pro);
    const sumValue = Object.values(percentage).reduce((a, b) => a + b, 0);
    return sumValue / Object.values(percentage).length;
};
